



















































































































































































































































































































































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import CardContainer from "@/components/CardContainer.vue"
import InputElement from "@/components/InputElement.vue"
import TextAreaElement from "@/components/TextAreaElement.vue"
import HerePlacesAutocomplete from "@/components/HerePlacesAutocomplete.vue"
import AddressInput from "@/components/AddressInput.vue"
import TimeSlotSelect from "@/components/TimeSlotSelect.vue"
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import { validationMixin } from 'vuelidate'
import { required, email, integer, minLength, maxLength, helpers, requiredIf } from 'vuelidate/lib/validators'
import { ROUTES_MAP } from '@/router'
import GTMService from "@/services/GTMService";
import CodiceFiscale from 'codice-fiscale-js';
import { isWishope } from "@/common/utils";
import InputRadio from '@/components/InputRadio.vue';


const fiscalCodePattern = helpers.regex(
  "fiscalCode",
  /^(?:[A-Z][AEIOU][AEIOUX]|[AEIOU]X{2}|[B-DF-HJ-NP-TV-Z]{2}[A-Z]){2}(?:[\dLMNP-V]{2}(?:[A-EHLMPR-T](?:[04LQ][1-9MNP-V]|[15MR][\dLMNP-V]|[26NS][0-8LMNP-U])|[DHPS][37PT][0L]|[ACELMRT][37PT][01LM]|[AC-EHLMPR-T][26NS][9V])|(?:[02468LNQSU][048LQU]|[13579MPRTV][26NS])B[26NS][9V])(?:[A-MZ][1-9MNP-V][\dLMNP-V]{2}|[A-M][0L](?:[1-9MNP-V][\dLMNP-V]|[0L][1-9MNP-V]))[A-Z]$/i
);

const VasAddressProps = Vue.extend({
  mixins: [validationMixin],
  computed: {
    ...mapState('global', [
      'cart'
    ]),
    ...mapState('vas', [
      'customerDetails',
      'selectedTimeslot',
      'shippingAddressPlace'
    ]),
    ...mapGetters('vas', [
      'merchant',
      'getDeliverySlots',
      'hasScheduledPickupAvailable',
      'hasTimeSlotDelivery',
      'isEnabled',
      'shippingAddress',
      'hasDelivery',
      'shippingDeliveryCost',
      'shippingDeliveryThreshold',
    ])
  },
  validations() {
    const validations: any = {
      address: {

      },
      firstname: {
        required: requiredIf(function (this: any) {
          return this.userType === this.userTypes.PRIVATE
        }),
        maxLength: maxLength(40),
        minLength: minLength(2)
      },
      lastname: {
        required: requiredIf(function (this: any) {
          return this.userType === this.userTypes.PRIVATE
        }),        maxLength: maxLength(40),
        minLength: minLength(2)
      },
      email: {
        required: requiredIf(function (this: any) {
          return this.userType === this.userTypes.PRIVATE
        }),        email,
      },
      fiscalCode: {
        required: requiredIf(function (this: any) {
          return this.userType === this.userTypes.PRIVATE
        }),        fiscalCodePattern,
        checkName() {
          let that: any = this;
          if (!that.firstname || !that.lastname || !that.fiscalCode) return true;
          const calculatedFiscalCode = that.getCalculatedFiscalCode();

          return that.fiscalCode.substring(0, 6) === calculatedFiscalCode.substring(0, 6)
        }
      },
      phone: {
        // required,
        integer,
        maxLength: maxLength(13),
        minLength: minLength(9)
      },
      notes: {
      },
      pickupPoint: {
      },
      message: {
      },
      // Company Data
      companyName: {
        required: requiredIf(function (this: any) {
          return this.userType === this.userTypes.COMPANY
        })
      },
      vatNumber: {
        required: requiredIf(function (this: any) {
          return this.userType === this.userTypes.COMPANY
        }),
        maxLength: maxLength(20),
        minLength: minLength(5)
      },
      sdi: {
        required: requiredIf(function (this: any) {
          return this.userType === this.userTypes.COMPANY
        }),
      },
      companyAddress: {
      },
      street: {},
      streetNumber: {},
      city: {},
      province: {},
      cap: {},
    }

    if (this.hasDelivery || this.getIsVasOrderAndPay()) {
      validations['notes'] = {
        // required
        // maxLength: maxLength(40),
      }

  
        if (this.addressAutocomplete) {
          validations[this.userType === this.userTypes.PRIVATE ? 'address' : 'companyAddress'] = {
            required
          }
        } else {
          validations['street'] = { required, minLength: minLength(3) }
          validations['streetNumber'] = { required }
          validations['city'] = { required }
          validations['province'] = { required, maxLength: maxLength(2)}
          validations['cap'] = { integer, required,  minLength: minLength(5), maxLength: maxLength(5) }
        }
        
      
    }

    if (this.getIsVasOrderAndPay() && this.pickupPoints.length > 0) {
      validations['pickupPoint'] = {
        required
      }
    }

    return validations
  },
  methods: {
    isWishope,
    getCalculatedFiscalCode() {
      let that: any = this;
      var cf = new CodiceFiscale({
        name: that.firstname,
        surname: that.lastname,
        gender: "M", //fake data
        day: 1, //fake data
        month: 1,//fake data
        year: 1975,//fake data
        birthplace: "Milano",//fake data
        birthplaceProvincia: "MI" //fake data
      });

      let data = JSON.parse(JSON.stringify(cf));

      return data.cf;
    },

    getIsVasOrderAndPay() {
      return this.cart.vasType == 'ORDER_AND_PAY';
    },

    handleSelect(selection: string) {
      this.userType = selection;
      this.resetForm();
      this.$v.$reset();
      //this.$v.$touch();
      this.$v.address.$model = null;
      this.$v.companyAddress.$model = null;
      this.printFormValidation();
      this.$root.$emit("onShippingAddressFormValidChange", !this.$v.$invalid);
      
    },

    capitalizeProvince() {
      if (this.$v.province.$model) {
        this.$v.province.$model = this.$v.province.$model.toUpperCase()
      }
    },

    resetForm() {
      this.$v.address.$model = null;
      this.$v.email.$model = null;
      this.$v.firstname.$model = null;
      this.$v.fiscalCode.$model = null;
      this.$v.lastname.$model = null;
      this.$v.message.$model = null;
      this.$v.notes.$model = null;
      this.$v.companyName.$model = null;
      this.$v.vatNumber.$model = null;
      this.$v.sdi.$model = null;
      this.$v.companyAddress.$model = null;
    },

    printFormValidation() {
      console.log("FORM INVALID: ", this.$v.$invalid)
      console.log("address INVALID: ", this.$v.address.$invalid ? "<<<<< YES >>>>>" : "no")
      console.log("email INVALID: ", this.$v.email.$invalid ? "<<<<< YES >>>>>" : "no")
      console.log("firstname INVALID: ", this.$v.firstname.$invalid ? "<<<<< YES >>>>>" : "no")
      console.log("fiscalCode INVALID: ", this.$v.fiscalCode.$invalid ? "<<<<< YES >>>>>" : "no")
      console.log("lastname INVALID: ", this.$v.lastname.$invalid ? "<<<<< YES >>>>>" : "no")
      console.log("message INVALID: ", this.$v.message.$invalid ? "<<<<< YES >>>>>" : "no")
      console.log("notes INVALID: ", this.$v.notes.$invalid ? "<<<<< YES >>>>>" : "no")
      console.log("phone INVALID: ", this.$v.phone.$invalid ? "<<<<< YES >>>>>" : "no")
      console.log("pickupPoint INVALID: ", this.$v.pickupPoint.$invalid ? "<<<<< YES >>>>>" : "no")
      console.log("data: ", this.$v)
    },

    toggleAddressAutocomplete() {
      this.addressAutocomplete = !this.addressAutocomplete;
    },

    fiscalCodeInputHandler() {
      this.$v.fiscalCode.onBlur = true as any;
      let that: any = this;
      that.fiscalCode = that.fiscalCode?.toUpperCase().trim().replace(/ /g, '');
    },
    ...mapActions('global', [
      'saveCustomerDetailsToCart'
    ]),
    ...mapMutations('vas', [
      'setCustomerDetails',
      'setShippingTimeSlot',
      'setShippingAddress'
    ])
  },
  mounted() {
    this.userType = this.userTypes.PRIVATE;
  },
  data: () => ({
    addressAutocomplete: true,
    pickupPoints: [],
    userTypes: {
      PRIVATE: "private",
      COMPANY: "company"
    },
    userType: ""
  })
})

@Component({
  components: {
    CardContainer,
    AddressInput,
    InputElement,
    TimeSlotSelect,
    TextAreaElement,
    HerePlacesAutocomplete,
    InputRadio
  }
})

export default class VasAddress extends VasAddressProps {
  error = false
  address = null
  notes = null
  firstname = null
  lastname = null
  fiscalCode = null
  email = null
  phone = null
  message = null
  pickupPoint = null
  selectedTime = null
  companyName = null
  vatNumber = null
  sdi = null
  companyAddress = null
  street = null
  streetNumber = null
  city = null
  province = null
  cap = null
  $refs!: {
    currentAddress: AddressInput;
  };

  @Watch('$v.$invalid') onFormInvalidChanged() {
    this.$root.$emit("onShippingAddressFormValidChange", !this.$v.$invalid);
  }

  get autoCompleteBounds() {
    return this.merchant ? this.merchant.configuration?.deliveryArea?.features[0]?.geometry.coordinates : []
  }

  get valid() {
    if (this.hasDelivery && !this.shippingAddress) return false
    return !this.$v.$invalid && this.customerDetails
  }

  get addressInvalidError() {
    if (!this.hasDelivery || this.shippingAddress) return false
    return !this.$v.$invalid && this.customerDetails
  }

  onAddressSelect({ address, place }: any) {
    this.address = address;
    place.address.state = place.address.countyCode; //Fix for missing countyCode field in export
    this.setShippingAddress(place)
  }

  onCompanyAddressSelect({ address, place }: any) {
    this.companyAddress = address;
    place.address.state = place.address.countyCode; //Fix for missing countyCode field in export
    this.setShippingAddress(place)
  }

  handleTimeSlot(timeslot: TimeSlot) {
    this.setShippingTimeSlot(timeslot)
  }

  gotoNextStep() {
    this.$router.push({ name: ROUTES_MAP.VAS_PAYMENT, params: this.$route.params })
  }

  async handleSubmit() {
    this.$v.$touch()
    if (this.$v.$invalid) return

    const message: string = this.message ?? "";

    console.log(this.pickupPoint);

    if (!this.addressAutocomplete) {
      if (this.userType === this.userTypes.COMPANY) {
        this.setCompanyFullAddress()
      } else {
        this.setFullAddress()
      }
    }

    const data = {
      firstname: this.firstname,
      lastname: this.lastname,
      email: this.email,
      fiscalCode: this.fiscalCode,
      telephone: this.phone,
      notes: this.notes,
      pickupPoint: this.pickupPoint,
      message: message ? message.replaceAll("\n", " ") : "",
    }

    if (this.userType === this.userTypes.COMPANY) {
      data.firstname = this.companyName;
      data.lastname = this.vatNumber;
      data.fiscalCode = this.sdi;
    }


    this.setCustomerDetails(data)

    if (!this.valid) return false
    try {
      if (this.hasDelivery) {
        await this.$refs.currentAddress.isCurrentAddressValid()
      }
      await this.saveCustomerDetailsToCart()
      this.gotoNextStep()
    } catch (error) {
      this.error = true
    }
  }

  async getVasPickupPoints() {
    this.pickupPoints = await this.$tinabaAPI.$vas.getVasPickupPointsPublic(this.merchant.businessId, this.merchant.shopId, this.cart.vasId);
    if (this.pickupPoints.length > 0) {
      this.$v.pickupPoint.$model = this.pickupPoints[0]['name'];
    }
  }

  setCompanyFullAddress() {
    this.companyAddress = `${this.street}, ${this.streetNumber}, ${this.cap} ${this.city} ${this.province}, Italia` as any;
    this.setShippingAddress({
      address: {
        city: this.city,
        countryCode: "ITA",
        countryName: "Italia",
        county: this.city,
        countyCode: this.province,
        district: "",
        houseNumber: this.streetNumber,
        label: this.companyAddress,
        postalCode: this.cap,
        state: this.province,
        street: this.street,
      }
    })
  }

  setFullAddress() {
    this.address = `${this.street}, ${this.streetNumber}, ${this.cap} ${this.city} ${this.province}, Italia` as any;
    this.setShippingAddress({
      address: {
        city: this.city,
        countryCode: "ITA",
        countryName: "Italia",
        county: this.city,
        countyCode: this.province,
        district: "",
        houseNumber: this.streetNumber,
        label: this.address,
        postalCode: this.cap,
        state: this.province,
        street: this.street,
      }
    })
  }

  created() {

    // GTMService.dataLayerCheckoutStep1(this.cart, this.merchant);

    this.$v.$reset()
    this.$root.$on("submitAddress", this.handleSubmit);
    if (this.customerDetails) {
      this.firstname = this.customerDetails.firstname
      this.lastname = this.customerDetails.lastname
      this.email = this.customerDetails.email
      this.fiscalCode = this.customerDetails.fiscalCode
      this.phone = this.customerDetails.telephone
      this.notes = this.customerDetails.notes
      this.pickupPoint = this.customerDetails.pickupPoint
      this.message = this.customerDetails.message
    }
    this.address = this.shippingAddressPlace?.title;

    if (this.cart.vasType == 'ORDER_AND_PAY') {
      this.getVasPickupPoints();
    }
  }
}
